import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { TypeDocumentaryConfig } from './shared/type-documentary.config.service';
import { Documental, TypeDocumentaryDataService } from './shared/type-documentary.data.service';

@Component({
  selector: 'iw-type-documentary',
  templateUrl: './type-documentary.component.html',
  styleUrls: ['./type-documentary.component.scss'],
  providers: [TypeDocumentaryDataService]
})
export class TypeDocumentaryComponent implements OnInit {
  //contiene la configuración de la tabla
  settings = {};
  // contiene los datos de la tabla
  source: LocalDataSource;
  //Datos para llenar la tabla
  table: any[] = [];
  // define si buscar los tipos documentales asociados o no
  //Esto porque si ya se modificó la tabla, no se vuelva a recargar con la consulta
  @Input() search: boolean = false;
  //tipos documentales disponibles
  typeDocumentaryList: Documental[] = [];
  // lista de tipos documentales a asociar
  @Input() set associateList(associate: number[]){
    this._associates = associate;
  }
  //guarda el id del control
  @Input() control_id: number;
  // Retorna los tipos documentales asociados
  @Output() typeDocumentary: EventEmitter<Array<any>> = new EventEmitter();
  //le indica al componente padre si cuando vuelva a entrar a este componente, deba volver a buscar en la api
  @Output() stopSearch: EventEmitter<boolean> = new EventEmitter()
  //lista de tipos documentales asociados
  private _associates: number[] = [];

  constructor(private tdds: TypeDocumentaryDataService) { }

  async ngOnInit() {
    //configuración inicial de la tabla
    const configTable = new TypeDocumentaryConfig();
    this.settings = configTable.settings;
    //suscripción a los eventos realizados en la tabla
    configTable.accion.subscribe((res: any) => {
      this.defineActionFunction(res.action, res.row);
    });
    //método que obtiene los tipos documentales
    await this.getTypeDocumentary();
    //si el control NO es nuevo, obtener los tipos documentales que ya están asociados
    if(this.control_id && !this.search){
      await this.getControlTypeDocumentary();
    }
  }

  get associateList(): number[] {
    return this._associates;
  }

  /**
   *Obtiene los tipos documentales, subseries y series
   *
   * @memberof TypeDocumentaryComponent
   */
  getTypeDocumentary() {
    this.tdds.getTypeDocumentary().subscribe(async (response) => {
      if(response){
        this.typeDocumentaryList = await response; 
        this.fillDataTable();
      }
    });
  }

  /**
   *Llena la tabla dependiendo de los tipos documentales asociados y los que no lo están
   *
   * @memberof TypeDocumentaryComponent
   */
  fillDataTable(){
    if(this.associateList.length){
      let exists: boolean;
      let data = {};
      this.typeDocumentaryList.forEach(item=>{
        exists = false;
        this.associateList.forEach(a=>{
          if(item.id == a){
            exists = true;
          }
        })
        if(exists){
          data = {
            serie_id: item.subserie.serie.id,
            serie: item.subserie.serie.nombre,
            subserie_id: item.subserie.id,
            subserie: item.subserie.nombre,
            tipo_documental_id: item.id,
            tipo_documental: item.nombre,
            associate: 'Si',
            funtions: 'NoFuntions'
          };
        }else{
          data = {
            serie_id: item.subserie.serie.id,
            serie: item.subserie.serie.nombre,
            subserie_id: item.subserie.id,
            subserie: item.subserie.nombre,
            tipo_documental_id: item.id,
            tipo_documental: item.nombre,
            associate: 'No',
          };
        }
        this.table.push(data);
      })
    }else{
      this.typeDocumentaryList.forEach(item=>{
        let data = {
          serie_id: item.subserie.serie.id,
          serie: item.subserie.serie.nombre,
          subserie_id: item.subserie.id,
          subserie: item.subserie.nombre,
          tipo_documental_id: item.id,
          tipo_documental: item.nombre,
          associate: 'No'
        };
        this.table.push(data);
      })
    }
    this.source = new LocalDataSource(this.table);
  }

  
  /**
   **Define las acciones al interactuar con los botones de la tabla
   *
   * @param {("asociar" | "eliminar")} action
   * @param {*} [data]
   * @memberof TypeDocumentaryComponent
   */
  defineActionFunction(action: "asociar" | "eliminar", data?: any){
    switch(action){
      case 'asociar':
        this.associate(data)
        break;
      case 'eliminar':
        this.delete(data);
        break;
    }
  }

  /**
   *Asocia los tipos documentales
   *
   * @param {*} data
   * @memberof TypeDocumentaryComponent
   */
  associate(data: any){
    this.table.forEach(t=>{
      if(t.tipo_documental_id == data.tipo_documental_id){
        this.associateList.push(t.tipo_documental_id);
        t['associate'] = 'Si'
        t['funtions'] = 'NoFuntions'
      }
    });
    this.source.refresh();
    this.saveList();
  }

  /**
   *Desasocia el tipo documental seleccionado
   *
   * @param {*} data
   * @memberof TypeDocumentaryComponent
   */
  delete(data: any){
    this.table.forEach(t=>{
      if(t.tipo_documental_id ==  data.tipo_documental_id){
        t['associate'] = 'No';
      }
    })
    let index = this.associateList.indexOf(data.tipo_documental_id);
    this.associateList.splice(index, 1);
    this.source.refresh();
    this.saveList()
  }

  /**
   *Emite los cambios hechos en la tabla
   *Guarda la lista de asociados en el componente padre
   * @memberof TypeDocumentaryComponent
   */
  saveList(){
    this.typeDocumentary.emit(this.associateList);
    this.stopSearch.emit(true);
  }

  /**
   *Obtiene los tipos documentales si el control ya existe 
   *Actualiza la tabla
   * @memberof TypeDocumentaryComponent
   */
  async getControlTypeDocumentary(){
    await this.tdds.getTypeDocumentaryControl(this.control_id).subscribe(async res=>{
      if(res){
        await res.forEach(r=>{
          this.associateList.push(r.id);
        });
        this.table.length = 0;
        //llenar la tabla
        this.fillDataTable();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/type-documentary/type-documentary.component.ts